// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutModal_container_D2ShR"};